import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { IconButton } from 'components/shared/IconButton/IconButton'

import { ArrowLeftIcon } from 'components/shared/Icon/model'

import styles from './PaneHeader.module.scss'

export const PaneHeader = ({
  children,
  className,
  contentClassName,
  direction = 'row',
  subtitle,
  title,
  onBack,
}) => (
  <Box
    align="center"
    className={cx(styles.header, { [className]: Boolean(className) })}
    justify={title ? 'flex-start' : 'flex-end'}
  >
    {!R.isNil(title) ? (
      <Box
        align="flex-start"
        className={cx(styles.content, {
          [contentClassName]: Boolean(contentClassName),
        })}
        {...{ direction }}
      >
        {onBack ? (
          <IconButton
            className={styles.back}
            icon={ArrowLeftIcon}
            size="medium"
            variant="text"
            onClick={onBack}
          />
        ) : null}
        <h1 className={styles.title}>{title}</h1>
        {!R.isNil(subtitle) ? (
          <h2 className={styles.subtitle}>{subtitle}</h2>
        ) : null}
      </Box>
    ) : null}
    {children}
  </Box>
)
